<template>
  <button @click="togglePlay" class="product-play" :class="rootClasses" :aria-disabled="hasFooterError || hideContent || null">
    <icon-info class="product-play__icon" v-if="hasFooterError && !hideContent" />
    <icon-play class="product-play__icon product-play__icon--play" v-else-if="! isPlaying && !hideContent"/>
    <icon-pause class="product-play__icon" v-else-if="!hideContent" />
    <span v-if="showText && !hideContent" class="product-play__text">
      Play Demo
    </span>
  </button>
</template>

<script lang="ts">
import IconPlay from '~/assets/icons/IconPlay.svg';
import IconPause from '~/assets/icons/IconPause.svg';
import IconInfo from '~/assets/icons/IconInfo.svg';
import { useAudioPlayerStore } from "~/stores/audioplayer";
import { getAudioKey } from "~/utils/audioplayer";

export default {
  props: {
    productDetails: Object,
    mediumSize: Boolean,
    reducedSize: Boolean,
    showText: Boolean,
    soundcloudId: [String, Number],
    hideContent: {
      type: Boolean,
      default: false,
    },
    onToggle: Function,
  },
  setup() {
    const audioPlayerStore = useAudioPlayerStore()

    return { audioPlayerStore }
  },
  components: {
    IconPlay,
    IconPause,
    IconInfo,
  },
  computed: {
    isPlaying() {
      return (this.productDetails && this.audioPlayerStore)
        && (getAudioKey(this.productDetails) == getAudioKey(this.audioPlayerStore?.loadedProductDetails))
        && this.audioPlayerStore.isPlaying;
    },
    hasFooterError() {
      return !!this.audioPlayerStore?.audioErrorMessage && !!this.reducedSize;
    },
    rootClasses () {
      return {
        'product-play--medium': this.mediumSize,
        'product-play--smaller': this.reducedSize,
        'product-play--with-text': this.showText,
        'is-disabled': this.hasFooterError || this.hideContent,
      };
    },
  },
  methods: {
    togglePlay() {
      if (this.hasFooterError || this.hideContent) return;

      if (typeof this.onToggle === 'function') {
        this.onToggle();
        return;
      }

      if (! this.audioPlayerStore?.loadedProductDetails
        || (getAudioKey(this.audioPlayerStore.loadedProductDetails) !== getAudioKey(this.productDetails))) {
        this.audioPlayerStore.loadFooterAudio(this.productDetails, true)
        return
      }

      this.audioPlayerStore.togglePlay();
    }
  }
};
</script>

<style lang="scss">
@use "~/common/scss/helpers";

.product-play {
  $root: &;

  align-items: center;
  color: currentColor;
  display: flex;
  flex: 0 0 1em;
  font-size: helpers.px-to-rem(60);
  height: 1em;
  justify-content: center;
  width: 1em;
  cursor: pointer;

  &--medium {
    font-size: helpers.px-to-rem(46);
  }

  &--smaller {
    font-size: helpers.px-to-rem(40);
  }

  &--with-text {
    flex: 0 0 auto;
    gap: .5rem;
    min-width: 1em;
    width: auto;
  }

  &__icon {
    height: 1em;
    width: 1em;

    #{$root}--with-text & {
      height: .5em;
      width: .5em;
    }
  }

  &__text {
    font-size: 1.5rem;
  }

  &.is-disabled {
    cursor: default;
  }
}
</style>
